module.exports = __webpack_public_path__ + "img/_logo-usps-icon.8c96f105.svg";